import { v4 as uuid } from 'uuid'
import { prefixKey, storageKeys } from '@/shared/consts/storageKeys'

export const getAccessToken = (): string | undefined => {
  return localStorage.getItem(storageKeys.token) ?? undefined
}

export const removeAccessToken = () => {
  localStorage.removeItem(storageKeys.token)
  localStorage.removeItem(storageKeys.refreshToken)
  localStorage.removeItem(storageKeys.validadeRefreshToken)
  localStorage.removeItem(storageKeys.validadeToken)
}

export const getSessionId = (): string | null => {
  const sessionId = sessionStorage.getItem(storageKeys.sessionId)

  if (!sessionId) {
    const newSessionId = uuid()
    sessionStorage.setItem(storageKeys.sessionId, newSessionId)
    return newSessionId
  }

  return sessionId
}

export const getDeviceId = (): string => {
  const deviceId = localStorage.getItem(storageKeys.deviceId)

  return deviceId || ''
}

export const setInLocalStorage = (storageKeys: string, value: any) => {
  const key = _buildCompleteKey(storageKeys)

  if (typeof value === 'object') {
    return localStorage.setItem(key, JSON.stringify(value))
  }

  return localStorage.setItem(key, value)
}

export const getFromLocalStorage = (
  storageKeys: string,
  useKeyPrefix = true
) => {
  const key = useKeyPrefix ? _buildCompleteKey(storageKeys) : storageKeys
  const item = localStorage.getItem(key)

  if (!item) return null

  try {
    return JSON.parse(item)
  } catch {
    return item
  }
}

export const setInSessionStorage = (
  storageKeys: string,
  value: string | Record<string, any>
) => {
  const key = _buildCompleteKey(storageKeys)

  if (typeof value === 'object') {
    return sessionStorage.setItem(key, JSON.stringify(value))
  }

  return sessionStorage.setItem(key, value)
}

export const getFromSessionStorage = <T = any>(
  storageKeys: string,
  useKeyPrefix = true
): T | null => {
  const key = useKeyPrefix ? _buildCompleteKey(storageKeys) : storageKeys
  const item = sessionStorage.getItem(key)

  if (!item) return null

  try {
    return JSON.parse(item) as T
  } catch {
    return item as T
  }
}

export const deletFromSessionStorage = (storageKeys: string) => {
  const key = _buildCompleteKey(storageKeys)

  return sessionStorage.removeItem(key)
}

export const deleteFromLocalStorage = (storageKey: string) => {
  const key = _buildCompleteKey(storageKey)

  return localStorage.removeItem(key)
}

export const getFromStorageBasedOnDeviceType = (key: string) => {
  if (window?.innerWidth < 992) return getFromSessionStorage(key)

  return getFromLocalStorage(key)
}

export const setInStorageBasedOnDevice = (key: string, value: any) => {
  if (window?.innerWidth < 992) return setInSessionStorage(key, value)

  return setInLocalStorage(key, value)
}

const _buildCompleteKey = (storageKeys: string) => {
  return `${prefixKey}-#-${storageKeys}`
}

export const getUtmExamsFromSessionStorage = () => {
  const utms = sessionStorage.getItem('AP-MARCAR-EXAME-#-exame_utm_params')

  if (!utms) return null

  try {
    return JSON.parse(utms)
  } catch {
    return null
  }
}
